module.exports = __webpack_public_path__ + "img/icon-move-email.4a756734.png";